// Generated by ScalaTS 0.8.2: https://scala-ts.github.io/scala-ts/

declare var exports: any;

export const nsSick = exports;

export const SickInhabitant = 'Sick';

export type Sick = typeof SickInhabitant;

export function isSick(v: any): v is Sick {
  return SickInhabitant == v;
}

export type SickSingleton = Sick;
